// extracted by mini-css-extract-plugin
module.exports = {"content":"growth_content__qdXE4","titleContainer":"growth_titleContainer__G9EnW","title":"growth_title__57MIw"};